

export const environment = {
  production: false,
  gaMeasurementId: "GTM-WG8NN9K3",
  gaDebug: true,
  useMock: true
};
